import { createElement, FC } from 'react';

import { AspectRatio, CreativeFormatNetwork } from '../../../generated/graphql';
import AmazonDevice11 from '../primitive/AmazonDevice11';
import AmazonDevice169 from '../primitive/AmazonDevice169';
import AmazonDevice916 from '../primitive/AmazonDevice916';
import AppleDevice11 from '../primitive/AppleDevice11';
import AppleDevice169 from '../primitive/AppleDevice169';
import AppleDevice916 from '../primitive/AppleDevice916';
import FacebookDevice11 from '../primitive/FacebookDevice11';
import FacebookDevice169 from '../primitive/FacebookDevice169';
import FacebookDevice916 from '../primitive/FacebookDevice916';
import GoogleDevice11 from '../primitive/GoogleDevice11';
import GoogleDevice169 from '../primitive/GoogleDevice169';
import GoogleDevice916 from '../primitive/GoogleDevice916';
import InstagramDevice11 from '../primitive/InstagramDevice11';
import InstagramDevice169 from '../primitive/InstagramDevice169';
import InstagramDevice916 from '../primitive/InstagramDevice916';
import LineDevice11 from '../primitive/LineDevice11';
import LineDevice169 from '../primitive/LineDevice169';
import LineDevice916 from '../primitive/LineDevice916';
import OwnedMediaDevice11 from '../primitive/OwnedMediaDevice11';
import OwnedMediaDevice169 from '../primitive/OwnedMediaDevice169';
import OwnedMediaDevice916 from '../primitive/OwnedMediaDevice916';
import SnapchatDevice11 from '../primitive/SnapchatDevice11';
import SnapchatDevice169 from '../primitive/SnapchatDevice169';
import SnapchatDevice916 from '../primitive/SnapchatDevice916';
import TwitterDevice11 from '../primitive/TwitterDevice11';
import TwitterDevice169 from '../primitive/TwitterDevice169';
import TwitterDevice916 from '../primitive/TwitterDevice916';
import YahooDevice11 from '../primitive/YahooDevice11';
import YahooDevice169 from '../primitive/YahooDevice169';
import YahooDevice916 from '../primitive/YahooDevice916';
import YoutubeDevice11 from '../primitive/YoutubeDevice11';
import YoutubeDevice169 from '../primitive/YoutubeDevice169';
import YoutubeDevice916 from '../primitive/YoutubeDevice916';

type Props = {
  network: CreativeFormatNetwork;
  aspectRatio: AspectRatio | null;
  className?: string;
};

const CreativeFormatDevice: FC<Props> = ({ network, aspectRatio, className }) => {
  const aspect: 'square' | 'portrait' | 'landscape' | null = !aspectRatio
    ? null
    : aspectRatio.width === aspectRatio.height
    ? 'square'
    : aspectRatio.width > aspectRatio.height
    ? 'landscape'
    : 'portrait';

  if (network.key === 'amazon') {
    if (aspect === 'landscape') {
      return <AmazonDevice169 className={className} />;
    }
    if (aspect === 'portrait') {
      return <AmazonDevice916 className={className} />;
    }
    if (aspect === 'square') {
      return <AmazonDevice11 className={className} />;
    }
    return <AmazonDevice169 className={className} />;
  }

  if (network.key === 'apple') {
    if (aspect === 'landscape') {
      return <AppleDevice169 className={className} />;
    }
    if (aspect === 'portrait') {
      return <AppleDevice916 className={className} />;
    }
    if (aspect === 'square') {
      return <AppleDevice11 className={className} />;
    }
    return <AppleDevice169 className={className} />;
  }
  if (network.key === 'facebook') {
    if (aspect === 'landscape') {
      return <FacebookDevice169 className={className} />;
    }
    if (aspect === 'portrait') {
      return <FacebookDevice916 className={className} />;
    }
    if (aspect === 'square') {
      return <FacebookDevice11 className={className} />;
    }
    return <FacebookDevice169 className={className} />;
  }
  if (network.key === 'google') {
    if (aspect === 'landscape') {
      return <GoogleDevice169 className={className} />;
    }
    if (aspect === 'portrait') {
      return <GoogleDevice916 className={className} />;
    }
    if (aspect === 'square') {
      return <GoogleDevice11 className={className} />;
    }
    return <GoogleDevice169 className={className} />;
  }
  if (network.key === 'instagram') {
    if (aspect === 'landscape') {
      return <InstagramDevice169 className={className} />;
    }
    if (aspect === 'portrait') {
      return <InstagramDevice916 className={className} />;
    }
    if (aspect === 'square') {
      return <InstagramDevice11 className={className} />;
    }
    return <InstagramDevice169 className={className} />;
  }
  if (network.key === 'line') {
    if (aspect === 'landscape') {
      return <LineDevice169 className={className} />;
    }
    if (aspect === 'portrait') {
      return <LineDevice916 className={className} />;
    }
    if (aspect === 'square') {
      return <LineDevice11 className={className} />;
    }
    return <LineDevice169 className={className} />;
  }
  if (network.key === 'other') {
    // otherの素材がないためOwnedMediaで代用
    if (aspect === 'landscape') {
      return <OwnedMediaDevice169 className={className} />;
    }
    if (aspect === 'portrait') {
      return <OwnedMediaDevice916 className={className} />;
    }
    if (aspect === 'square') {
      return <OwnedMediaDevice11 className={className} />;
    }
    return <OwnedMediaDevice169 className={className} />;
  }
  if (network.key === 'owned_media') {
    if (aspect === 'landscape') {
      return <OwnedMediaDevice169 className={className} />;
    }
    if (aspect === 'portrait') {
      return <OwnedMediaDevice916 className={className} />;
    }
    if (aspect === 'square') {
      return <OwnedMediaDevice11 className={className} />;
    }
    return <OwnedMediaDevice169 className={className} />;
  }
  if (network.key === 'snapchat') {
    if (aspect === 'landscape') {
      return <SnapchatDevice169 className={className} />;
    }
    if (aspect === 'portrait') {
      return <SnapchatDevice916 className={className} />;
    }
    if (aspect === 'square') {
      return <SnapchatDevice11 className={className} />;
    }
    return <SnapchatDevice169 className={className} />;
  }
  if (network.key === 'twitter') {
    if (aspect === 'landscape') {
      return <TwitterDevice169 className={className} />;
    }
    if (aspect === 'portrait') {
      return <TwitterDevice916 className={className} />;
    }
    if (aspect === 'square') {
      return <TwitterDevice11 className={className} />;
    }
    return <TwitterDevice169 className={className} />;
  }
  if (network.key === 'yahoo') {
    if (aspect === 'landscape') {
      <YahooDevice169 className={className} />;
    }
    if (aspect === 'portrait') {
      return <YahooDevice916 className={className} />;
    }
    if (aspect === 'square') {
      return <YahooDevice11 className={className} />;
    }
    return <YahooDevice169 className={className} />;
  }
  if (network.key === 'youtube') {
    if (aspect === 'landscape') {
      return <YoutubeDevice169 className={className} />;
    }
    if (aspect === 'portrait') {
      return <YoutubeDevice916 className={className} />;
    }
    if (aspect === 'square') {
      return <YoutubeDevice11 className={className} />;
    }
    return <YoutubeDevice169 className={className} />;
  }

  // どれにも該当しない場合でもOwnedMediaを代用する
  if (aspect === 'landscape') {
    return <OwnedMediaDevice169 className={className} />;
  }
  if (aspect === 'portrait') {
    return <OwnedMediaDevice916 className={className} />;
  }
  if (aspect === 'square') {
    return <OwnedMediaDevice11 className={className} />;
  }
  return <OwnedMediaDevice169 className={className} />;
};

export default CreativeFormatDevice;
